export const ErrorRefs = {
  "Unknown error": "00",
  "Failed to load JSON file": "01",
  "Failed to load PDF file": "02",
};
